import React from 'react';
import { SchemaInterface } from '@asyncapi/parser';
import { Schema } from '../Schema';
import { SchemaHelpers } from '../../../helpers';

interface ConditionsProps {
  schema: SchemaInterface;
  dependentSchemas?: SchemaInterface;
}

export const Conditions = ({ schema, dependentSchemas }: ConditionsProps) => {
  return (
    <div className={`space-y-2 bg-blue-100 border rounded rounded-tl-none p-4`}>
      {schema.oneOf()?.length && (
        <div className="">
          <h5 className="text-sm font-semibold text-gray-700 mb-2">
            Can be <strong>One Of</strong> the following:
          </h5>
          {schema.oneOf()?.map((s, idx) => (
            <Schema
              key={idx} // NOSONAR S6479
              schema={s}
              schemaName={SchemaHelpers.applicatorSchemaName(
                idx,
                '',
                '',
                s.title() ?? s.id(),
              )}
            />
          ))}
        </div>
      )}

      {schema.anyOf()?.length && (
        <div className="">
          <h5 className="text-sm font-semibold text-gray-700 mb-2">
            Can be <strong>Any Of</strong> the following:
          </h5>
          {schema.anyOf()?.map((s, idx) => (
            <Schema
              key={idx} // NOSONAR S6479
              schema={s}
              schemaName={SchemaHelpers.applicatorSchemaName(
                idx,
                '',
                '',
                s.title() ?? s.id(),
              )}
            />
          ))}
        </div>
      )}

      {schema.allOf()?.length && (
        <div className="">
          <h5 className="text-sm font-semibold text-gray-700 mb-2">
            Must consist <strong>All Of</strong> the following:
          </h5>
          {schema.allOf()?.map((s, idx) => (
            <Schema
              key={idx} // NOSONAR S6479
              schema={s}
              schemaName={SchemaHelpers.applicatorSchemaName(
                idx,
                '',
                '',
                s.title() ?? s.id(),
              )}
            />
          ))}
        </div>
      )}

      {schema.not() && (
        <Schema schema={schema.not()} schemaName="Can NOT adhere to:" />
      )}

      {schema.propertyNames() && (
        <Schema
          schema={schema.propertyNames()}
          schemaName="Property names must adhere to:"
        />
      )}

      {schema.contains() && (
        <Schema
          schema={schema.contains()}
          schemaName="Array must contain at least one of:"
        />
      )}

      {schema.if() && (
        <div className="">
          <Schema schema={schema.if()} schemaName="If schema adheres to:" />
          {schema.then() && (
            <Schema schema={schema.then()} schemaName="Then must adhere to:" />
          )}
          {schema.else() && (
            <Schema schema={schema.else()} schemaName="Otherwise:" />
          )}
        </div>
      )}

      {dependentSchemas && (
        <Schema schema={dependentSchemas} schemaName="Dependent schemas:" />
      )}
    </div>
  );
};
